// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Yf","centerLink":"Zf","productSection":"_f","item":"ag","ctaButton":"bg"};